import React, { useState, useRef, useEffect } from "react"
import {
  Container,
  Row,
  Form,
  Input,
  Label,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Card,
  CardBody,
  FormGroup,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
//  import { FontAwesomeIcon } from "@fortawesome/fontawesome-free"

import {
  bdCollectionsListing,
  bdDownloadExportCollectionCatalog,
} from "../../../store/actions"

function BdExportDownload(props) {
  document.title = "Export Download"
  const dispatch = useDispatch()

  // for admin start here
  const [currentData, setCurrentData] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const CollectionList = useSelector(state => state.bdCollection.collection)
  const exportData = useSelector(state => state.bdCollection.exportCollection)

  const bdInitialDetails = {
    export_type: null,
    price_to_export: null,
    collection_id: null,
  }
  const [bdDetails, setBdDetails] = useState(bdInitialDetails)

  function downloadData(e) {
    setModalOpen(true)
    dispatch(bdDownloadExportCollectionCatalog(bdDetails, props.history))
    e.preventDefault()
  }

  function handleExportSelection(e) {
    const { name, value } = e.target
    let newState = {}
    newState = bdDetails
    if (name === "export_selection") {
      let price_to_export = document.getElementsByClassName("price_to_export")
      for (let i = 0; i < price_to_export.length; i++) {
        price_to_export[i].checked = false
      }

      newState.export_type = value
      newState.price_to_export = null
      newState.collection_id = null
      if (value == "2") {
        // product_without_prices
        newState.type = "product"
        dispatch(bdCollectionsListing())
      } else {
        // newState.type = "offer"
        newState.type = null
      }
    } else if (name === "price_to_export") {
      newState.type = null
      newState.collection_id = null
      newState.type = "offer"
      newState.price_to_export = value
      dispatch(bdCollectionsListing())
    } else if (name === "collection") {
      newState.collection_id = value
      dispatch(bdCollectionsListing())
    }

    setBdDetails(prevState => ({
      ...prevState,
      ...newState,
    }))
  }

  useEffect(() => {
    if (CollectionList && CollectionList.length > 0) {
      setCurrentData(CollectionList)
    }
  }, [bdDetails, CollectionList])

  const { error, loading } = useSelector(state => ({
    error: state.bdCollection.error,
    loading: state.bdCollection.loading,
  }))

  function moveToDownload() {
    setModalOpen(!modalOpen)
    props.history.push("/export/download")
  }

  function updateModalState() {
    let currentStateModal = !modalOpen
    setModalOpen(currentStateModal)
  }

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Export" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}

                  <Form id="exportForm" method="post">
                    <Row>
                      <Col md={12}>
                        <div className="mb-3">
                          <FormGroup check inline>
                            <Input
                              type="radio"
                              className="form-check-input"
                              name="export_selection"
                              value="1"
                              onChange={e => handleExportSelection(e)}
                              id="export_selection_bd_product_with_prices"
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="export_selection_bd_product_with_prices"
                            >
                              Export Product catalogue <b>with prices</b> based
                              on offers ?
                            </Label>
                          </FormGroup>
                          <br />
                          <FormGroup check inline>
                            <Input
                              type="radio"
                              className="form-check-input"
                              name="export_selection"
                              value="2"
                              onChange={e => handleExportSelection(e)}
                              id="export_selection_bd_product_without_prices"
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="export_selection_bd_product_without_prices"
                            >
                              Export Product catalogue <b>without prices</b>{" "}
                              based on products ?
                            </Label>
                          </FormGroup>
                        </div>
                      </Col>

                      {bdDetails.export_type ? (
                        bdDetails.export_type !== "2" ? (
                          <Col md={12}>
                            <div className="with_or_without_prices">
                              <hr />
                              <strong>
                                <i>Select price to export</i>
                              </strong>
                              <br />
                              <br />
                              <FormGroup check inline>
                                <Input
                                  type="radio"
                                  value="purchase_price_fsc"
                                  className="form-check-input price_to_export"
                                  name="price_to_export"
                                  onChange={handleExportSelection}
                                  id="price_export_bd_purchase_price"
                                />
                                <Label
                                  className="form-check-label"
                                  htmlFor="price_export_bd_purchase_price"
                                >
                                  Purchase Price (FSC)
                                </Label>
                              </FormGroup>
                              <br />
                              <FormGroup check inline>
                                <Input
                                  type="radio"
                                  value="purchase_price_non_fsc "
                                  className="form-check-input price_to_export"
                                  name="price_to_export"
                                  onChange={handleExportSelection}
                                  id="price_export_bd_purchase_price_non_fsc"
                                />
                                <Label
                                  className="form-check-label"
                                  htmlFor="price_export_bd_purchase_price_non_fsc"
                                >
                                  Purchase Price (Non-FSC)
                                </Label>
                              </FormGroup>
                              <br />
                            </div>
                          </Col>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}

                      {bdDetails.price_to_export ? (
                        bdDetails.price_to_export !== "product" ? (
                          <Col md={12}>
                            <div
                              className="collection"
                              id="offer_product_collection"
                            >
                              <hr />
                              <strong>
                                <i>Select offer collection</i>
                              </strong>
                              <br />
                              <br />
                              <select
                                name="collection"
                                className="form-control"
                                onChange={handleExportSelection}
                              >
                                <option value="">Choose...</option>
                                {currentData &&
                                  currentData.map((cr, pc) =>
                                    cr.collection_type == "offer" ? (
                                      <option key={"op" + pc} value={cr.id}>
                                        {cr.collection_name +
                                          " (" +
                                          cr.item_count +
                                          ")"}
                                      </option>
                                    ) : (
                                      ""
                                    )
                                  )}
                              </select>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}

                      {bdDetails &&
                      bdDetails.price_to_export === null &&
                      bdDetails.type == "product" ? (
                        <Col md={12}>
                          <div
                            className="collection"
                            id="offer_product_collection"
                          >
                            <hr />
                            <strong>
                              <i>Select product collection</i>
                            </strong>
                            <br />
                            <br />
                            <select
                              name="collection"
                              className="form-control"
                              onChange={handleExportSelection}
                            >
                              <option value="">Choose...</option>
                              {currentData &&
                                currentData.map((cr, pc) =>
                                  cr.collection_type == "product" ? (
                                    <option key={"op" + pc} value={cr.id}>
                                      {cr.collection_name +
                                        " (" +
                                        cr.item_count +
                                        ")"}
                                    </option>
                                  ) : (
                                    ""
                                  )
                                )}
                            </select>
                          </div>
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                    <Row>
                      <Col md={6} className="mt-2">
                        {bdDetails && bdDetails.collection_id ? (
                          <button
                            className="btn btn-primary text-end mt-2"
                            onClick={e => downloadData(e)}
                          >
                            {loading ? "Loading ..." : "Export now"}
                          </button>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col md={6} className="text-end mt-2"></Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          isOpen={modalOpen}
          role="dialog"
          autoFocus={true}
          centered={true}
          className="deleteProductConfirm"
          tabIndex="-1"
          backdrop={false}
          toggle={() => updateModalState()}
        >
          <ModalHeader>Download Export</ModalHeader>
          <ModalBody>
            You export is being processed. Depending on how many products,
            exporting can take several minutes. Please check the status in the
            download section.
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={moveToDownload}>
              Ok
            </Button>{" "}
            {/* <Button onClick={() => updateModalState()}>No</Button> */}
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default BdExportDownload
